import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setHomepageCategory } from "redux/actions/homepageCategoriesActions";

import { homepageSmartFormBoxSX } from "../../styled/styledSXProperties/styledBoxSX";
import {
    homepageSmartFormCardMobileSX,
    homepageSmartFormCardSX,
} from "../../styled/styledSXProperties/styledCardSX";
import { homepageIconDispatcher } from "./homePageIcon";

const HomepageCard = ({ name, data, team, isDesktop }) => {
    const dispatch = useDispatch();

    let l3CategoryCodes = null;
    const category = Object.values(data[name]);

    category.forEach((cat) => {
        if (cat?.length) {
            l3CategoryCodes += cat.length;
        }
    });

    function handleSelection(name) {
        dispatch(setHomepageCategory(name, data[name], team));
    }

    const selectIcon = () => {
        const matchedKey = Object.keys(homepageIconDispatcher).find((key) =>
            team.toLowerCase().includes(key)
        );
        return matchedKey
            ? homepageIconDispatcher[matchedKey]
            : homepageIconDispatcher["default"];
    };

    const darkMode = useSelector((state) => state.general.darkMode);

    return (
        <>
            <Card
                sx={
                    isDesktop
                        ? homepageSmartFormCardSX(darkMode)
                        : homepageSmartFormCardMobileSX(darkMode)
                }
            >
                <Grid container spacing={1}>
                    <Grid item xs={7}>
                        <Box sx={homepageSmartFormBoxSX(darkMode)}>
                            {selectIcon()()}
                        </Box>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography
                            variant="body2"
                            fontWeight="normal"
                            align="right"
                            color="text.secondary"
                        >
                            Total Codes
                        </Typography>
                        <Typography
                            variant="h3"
                            fontWeight="bold"
                            align="right"
                        >
                            {l3CategoryCodes ? l3CategoryCodes : 0}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h6" fontWeight="light">
                            {name}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Button
                        size="small"
                        color="secondary"
                        endIcon={<ArrowForwardIcon />}
                        onClick={() => handleSelection(name)}
                    >
                        Browse Subcategories{" "}
                    </Button>
                </Grid>
            </Card>
        </>
    );
};

export default HomepageCard;
